'use client';

import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { HelpCircle } from 'lucide-react';
import { HelpCenter } from './help-center';
import { isHelpSystemEnabled } from '@/lib/feature-flags';

export function HelpButton() {
  const [helpOpen, setHelpOpen] = useState(false);

  // Don't render if help system is disabled
  if (!isHelpSystemEnabled()) {
    return null;
  }

  return (
    <>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setHelpOpen(true)}
            aria-label="Open help center"
            data-tour="help-button"
          >
            <HelpCircle className="h-5 w-5" />
          </Button>
        </TooltipTrigger>
        <TooltipContent side="bottom">Help</TooltipContent>
      </Tooltip>
      <HelpCenter open={helpOpen} onOpenChange={setHelpOpen} />
    </>
  );
}

